/* Vintedoisk — galeria do produto com quadros do MESMO tamanho (25/10/2026, pedido do Rodrigo: "só o tamanho").
   As fotos do fornecedor não são alteradas. Todo quadro é 2:3 (vk-produto.css) e a foto aparece inteira dentro dele;
   para não sobrar faixa de outra cor, o quadro pega a cor do fundo da própria foto (lida numa miniatura de 48 px).
   Foto de cena (borda sem cor única: pessoa, cenário) preenche o quadro (classe vk-cena) — a foto inteira segue no zoom. */
(function () {
  var SEL = '.product-information__media .product-media-container:not(.product-media-container--video)';

  function miniatura(src) {
    try { var u = new URL(src, location.href); u.searchParams.set('width', '48'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.href; }
    catch (e) { return null; }
  }

  function analisar(caixa) {
    if (caixa.dataset.vkMoldura) return;
    var img = caixa.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return;
    caixa.dataset.vkMoldura = '1';
    var url = miniatura(src); if (!url) return;
    var t = new Image();
    t.crossOrigin = 'anonymous';
    t.onload = function () {
      try {
        var w = t.naturalWidth, h = t.naturalHeight, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(t, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data, px = [];
        for (var x = 0; x < w; x++) { px.push(x, x + (h - 1) * w); }
        for (var y = 1; y < h - 1; y++) { px.push(y * w, y * w + w - 1); }
        var r = [], g = [], b = [];
        px.forEach(function (i) { r.push(d[i * 4]); g.push(d[i * 4 + 1]); b.push(d[i * 4 + 2]); });
        var med = function (a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
        var mr = med(r), mg = med(g), mb = med(b), iguais = 0;
        for (var k = 0; k < r.length; k++) if (Math.abs(r[k] - mr) + Math.abs(g[k] - mg) + Math.abs(b[k] - mb) <= 24) iguais++;
        if (iguais / r.length >= 0.85) caixa.style.setProperty('--vk-moldura', 'rgb(' + mr + ',' + mg + ',' + mb + ')');
        else caixa.classList.add('vk-cena');
      } catch (e) { /* sem leitura da cor: fica o branco padrão */ }
    };
    t.src = url;
  }

  function varrer() { document.querySelectorAll(SEL).forEach(analisar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer); else varrer();
  // troca de variante/cor redesenha a galeria
  new MutationObserver(function () { clearTimeout(varrer.t); varrer.t = setTimeout(varrer, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
